// @flow

import { Component } from '../jsti/core';
import Notifications from '../constants/Notifications';
import Toggle from '../components/Toggle';

export default class CartTotalCounter extends Component {
  /**
   * Initialize the component
   *
   * @param pEl
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);

    this.addListener(Notifications.CART_UPDATE_DATA, this.update);
    this.addListener(Notifications.CART_SHOW_TOTAL_COUNTER, this.showTotalCartCounter);
  }

  /**
   * Update the counter
   */
  update({ count }: Object): void {
    this.el.innerText = count;
  }

  /**
   * Show the counter
   */
  showTotalCartCounter(): void {
    Toggle.show(this.el, 'hidden');
  }
}
